// The Different partitions in the dashboard (ie Announcements, Tasks, Projects, RFIs, Submittals, Invoices, Contact Us)

import { TaskProps } from "@/interfaces/tasks_types"
import { TaskCard } from "../../Cards/TaskCard"

type TaskInnerContainerProps = {
    tasks: TaskProps[],
    isNewCard: (cardType: string, id: string) => boolean,
    markAsSeen: (cardType: string, id: string) => void
}
// This container contains the Tasks per project
export function TaskInnerContainer({tasks, isNewCard, markAsSeen}: TaskInnerContainerProps) {
    return (
        <div className="overflow-y-auto h-fit max-h-[60vh] ">
            {tasks.map((task) => (
                <TaskCard 
                    task={task} 
                    key={task.task_id} 
                    isNew={isNewCard('task', task.task_id ?? '')} 
                    onView={() => markAsSeen('task', task.task_id ?? '')} 
                />
            ))}
        </div>
    )
}
